import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "../components/utils/request";
import { useAuthStore } from "../stores/authStore";
const dataListProperties = async ({ page, limit, token, name, type }) => {
  const response = await get({
    path: `/client/properties?page=${page}&limit=${limit}${
      type ? `&type=${type}` : ""
    }${name ? `&name=${name}` : ""}`,
    token,
  });

  return response;
};
export const useDataListProperties = (l = 10) => {
  const { auth } = useAuthStore();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(l);
  const [name, setName] = useState(undefined);
  const [type, setType] = useState("all");
  const dataListPropertiesQuery = useQuery({
    queryKey: [
      "dataListProperties",
      {
        page,
        limit,
        token: auth.accessToken,
        name,
        type,
      },
    ],
    queryFn: () =>
      dataListProperties({
        page,
        limit,
        token: auth.accessToken,
        name,
        type,
      }),
  });

  const searchName = async (name) => {
    setName(name);
    setType(undefined);
  };

  const searchType = async (type) => {
    setType(type);
    setName(undefined);
  };
  /*  console.log({
    status: dataListPropertiesQuery.status,
    data: dataListPropertiesQuery.data,
    isFetching: dataListPropertiesQuery.isFetching,
    error: dataListPropertiesQuery.error,
  }); */
  return {
    dataListPropertiesQuery: {
      ...dataListPropertiesQuery,
      setPage,
      setLimit,
      searchName,
      setType,
      type,
      searchType,
    },
  };
};
